import axios from "axios";
import baseURL, { ticketBaseURL } from "../config/api";

export const upload_CommonFile = (formData: FormData, token: string) => {
    return axios({
        url: `${baseURL}commonFile/upload`,
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
        },
        data: formData
    }).then(response => response.data);
};

export const upload_CommonFileSupportTicket = (formData: FormData) => {
    return axios({
        url: `${ticketBaseURL}commonFile/upload`,
        method: "POST",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
    }).then(response => response.data);
};